import { Grid } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { ReactComponent as InfoIcon } from "assets/icons/InfoIcon.svg";
import { InputField } from "components/InputField/InputField";
import { postalCodeLabel } from "helper/postalCodeFormat";
import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import {
  GridItem,
  PersonalDetailsTitle,
  PersonalDetailsWrapper,
  ReserveLoginButton,
} from "./Theme";
import { Fonts } from "theme/fontConfig";

export const PersonalDetailsCard = ({
  formik,
  isAuthenticated,
  handleLogout,
  showZipCode,
}) => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const accountIdParams = searchParams.get("accountId");

  const isMobile = useMediaQuery("(max-width:600px)");
  const memberPortal = localStorage.getItem("memberPortal") === "true" || false;

  const postalLabel = postalCodeLabel();
  const isFirstNameExist =
    !formik?.values?.accountInfo?.first_name ||
    formik?.values?.accountInfo?.first_name === "";
  const isLasttNameExist =
    !formik?.values?.accountInfo?.last_name ||
    formik?.values?.accountInfo?.last_name === "";
  const isEmailExist =
    !formik?.values?.accountInfo?.email ||
    formik?.values?.accountInfo?.email === "";
  const isZipExist =
    !formik?.values?.cardsDetails?.zip ||
    formik?.values?.cardsDetails?.zip === "";

  const handleInputFields = (e, name) => {
    let value = e.target.value;
    value = value?.trimStart();
    formik.setFieldValue(name, value);
  };

  const handleRemoveSpaces = (e, name) => {
    let value = e.target.value;
    value = value?.trim();
    formik.setFieldValue(name, value);
  };

  const handleReserveLogin = () => {
    if (isAuthenticated) {
      handleLogout();
      return;
    }
    localStorage.setItem(
      "redirectUrl",
      `/charges?accountId=${accountIdParams}`
    );
    window.location.href = "/login";
  };

  const externalLogin = useMemo(() => (isAuthenticated ? "Logout" : "Login"), [
    isAuthenticated,
  ]);

  return (
    <PersonalDetailsWrapper style={isMobile ? { padding: "16px" } : undefined}>
      <PersonalDetailsTitle style={isMobile ? { marginBottom: "12px" } : undefined}>
        <div>
          <span>Billing Details </span>
        </div>
        {memberPortal && (
          <ReserveLoginButton onClick={handleReserveLogin}>
            {externalLogin}
          </ReserveLoginButton>
        )}
      </PersonalDetailsTitle>

      <Grid container spacing={2}>
        <Grid item xs={6}>
          <GridItem>
            <InputField
              isRequired={true}
              labelStyle={{
                color: isFirstNameExist && "var(--Gray-100, #B5B5C3)",
                fontSize: Fonts.GeneralLabelFont.fontSize,
                fontWeight: Fonts.GeneralLabelFont.fontWeight,
              }}
              placeholder="First Name"
              label="First Name"
              styleWrapper={{ width: "100%" }}
              style={{ width: "100%" }}
              isOptional={false}
              value={formik?.values?.accountInfo?.first_name || ""}
              name="first_name"
              handleChange={(e) => {
                handleInputFields(e, "accountInfo.first_name");
              }}
              onBlur={(e) => {
                handleRemoveSpaces(e, "accountInfo.first_name");
              }}
              readOnly={isAuthenticated}
            />
          </GridItem>
        </Grid>
        <Grid item xs={6}>
          <InputField
            isRequired={true}
            labelStyle={{
              color: isLasttNameExist && "var(--Gray-100, #B5B5C3)",
              fontSize: Fonts.GeneralLabelFont.fontSize,
              fontWeight: Fonts.GeneralLabelFont.fontWeight,
            }}
            placeholder="Last Name"
            label="Last Name"
            styleWrapper={{ width: "100%" }}
            style={{ width: "100%" }}
            isOptional={false}
            value={formik?.values?.accountInfo?.last_name || ""}
            name="last_name"
            handleChange={(e) => {
              handleInputFields(e, "accountInfo.last_name");
            }}
            onBlur={(e) => {
              handleRemoveSpaces(e, "accountInfo.last_name");
            }}
            readOnly={isAuthenticated}
          />
        </Grid>
        <Grid item xs={showZipCode ? 6 : 12}>
          <GridItem>
            <InputField
              isRequired={true}
              labelStyle={{
                color: isEmailExist && "var(--Gray-100, #B5B5C3)",
                fontSize: Fonts.GeneralLabelFont.fontSize,
                fontWeight: Fonts.GeneralLabelFont.fontWeight,
              }}
              placeholder="Email"
              label="Email"
              styleWrapper={{ width: "100%" }}
              style={{ width: "100%" }}
              isOptional={false}
              handleChange={(e) => {
                formik.setFieldValue("accountInfo.email", e?.target?.value);
              }}
              value={formik?.values?.accountInfo?.primary_email_address}
              readOnly={isAuthenticated && formik?.values?.accountInfo?.primary_email_address?.length > 0}
            />
          </GridItem>
        </Grid>
        {showZipCode && (
          <Grid item xs={6}>
            <GridItem>
              <InputField
                isRequired={true}
                labelStyle={{
                  color: isZipExist && "var(--Gray-100, #B5B5C3)",
                  fontSize: Fonts.GeneralLabelFont.fontSize,
                  fontWeight: Fonts.GeneralLabelFont.fontWeight,
                }}
                placeholder={postalLabel}
                label={postalLabel}
                styleWrapper={{ width: "100%" }}
                style={{ width: "100%" }}
                type="string"
                isOptional={false}
                handleChange={(e) => {
                  formik.setFieldValue("cardsDetails.zip", e?.target?.value);
                }}
                value={formik?.values?.cardsDetails?.zip}
                readOnly={isAuthenticated}
              />
            </GridItem>
          </Grid>
        )}
      </Grid>
    </PersonalDetailsWrapper>
  );
};
